export default "__VITE_ASSET__1JHNgWxI__"